<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs pt-5>
        <div class="px-md-5">
          <!-- {{ DataSession }} -->
          <!-- <CookiesTestWebscript /> -->
        </div>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import CookiesTestWebscript from "@/views/Admin/Cookies/CookiesTestWebscript.js";
export default {
  components: { CookiesTestWebscript },
  data: function () {
    return {
      DataSession: "",
    };
  },
  computed: {},
  mounted() {
    this.generateRandomNumber();
    const head = document.head || document.getElementsByTagName("head")[0];
    head.appendChild(CookiesTestWebscript);
  },
  methods: {
    generateRandomNumber() {
      const min = Math.pow(10, 9);
      const max = Math.pow(10, 10) - 1;
      this.DataSession = Math.floor(Math.random() * (max - min + 1)) + min;
    },
  },
};
</script>

<style>
</style>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}
</style>
